import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {ipadproMax, marketingMobileCuttoff} from "@css/constants";
import {Card, CardContent, CardText} from "@css/common.elements";
import {fontSize} from "@css/styles";
import {Button} from "@components/Button";


export const ArticleCallNowCardContainer = styled('div')(css`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: right;
`)

export const ArticleCallNowCardContent = styled(CardContent)(css`
  padding: 25px 0;
  width: 75%;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 85%;
  }
`)

export const ArticleCallNowStyledCard = styled(Card)(css`
`)

export const ArticleCallNowCardSubtitle = styled(CardText)(css`
  ${fontSize(16)};
`)

export const StyledButton = styled(Button)(css`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 10px;
`)

export const btnStyles = css`
  width: 100%;
  margin-top: 24px;
`
